import type { MessageKey } from '../i18n';

export interface SettingsWorkspaceSection {
  id: 'deidentification' | 'future';
  titleKey: MessageKey;
  descriptionKey: MessageKey;
  scope: 'graph';
  editable: boolean;
  placeholder?: boolean;
}

export const settingsWorkspaceSections: SettingsWorkspaceSection[] = [
  {
    id: 'deidentification',
    titleKey: 'settings.deidentification.title',
    descriptionKey: 'settings.deidentification.description',
    scope: 'graph',
    editable: true,
  },
  {
    id: 'future',
    titleKey: 'settings.future.title',
    descriptionKey: 'settings.future.description',
    scope: 'graph',
    editable: false,
    placeholder: true,
  },
];

export function getSettingsWorkspaceSections(readonlyMode: boolean): SettingsWorkspaceSection[] {
  return settingsWorkspaceSections.map((section) => ({
    ...section,
    editable: readonlyMode ? false : section.editable,
  }));
}

export function getDefaultSettingsWorkspaceSection(): SettingsWorkspaceSection['id'] {
  return 'deidentification';
}
